module.exports = __webpack_public_path__ + "img/img25.9e0a5ed8.png";